import * as mutations from "../mutations.js"
import { v4 as uuidv4 } from "uuid"

export default {
    namespaced: true,
    state: {
        messages: [],
        alert: []
    },
    getters: {
        messages: state => state.messages,
        alert: state => state.alert,
    },
    mutations: {
        [mutations.ADD_ALERT](state, alert) {
            let id = uuidv4();
            state.alert.push({
                id: id,
                ...alert,
            });
        },
        [mutations.REMOVE_ALERT](state, id) {
            state.alert.splice(state.alert.findIndex(a => a.id == id), 1);
        },
        [mutations.SET_MESSAGES](state, messages) {
            let defaultMessage = {
                duration: 4000,
                type: "info",
                message: "Message par défaut",
            }
            if (typeof messages == "object" && Array.isArray(messages)) {
                let id = uuidv4()
                setTimeout(() => {
                    let index = state.messages.findIndex(m => m.id == id);
                    if (index != -1) {
                        state.messages.splice(index, 1);
                    }
                }, defaultMessage.duration);
                state.messages.push(...messages.map(m => {
                    return {
                        id: id,
                        ...defaultMessage,
                        ...m,
                    }
                }));
            } else {
                let id = uuidv4()
                setTimeout(() => {
                    let index = state.messages.findIndex(m => m.id == id);
                    if (index != -1) {
                        state.messages.splice(index, 1);
                    }
                }, defaultMessage.duration);
                state.messages.push({
                    id: id,
                    ...defaultMessage,
                    ...messages,
                });
            }
        },
        [mutations.REMOVE_MESSAGE](state, id) {
            state.messages.splice(state.messages.findIndex(m => m.id == id), 1);
        }
    },
    actions: {
        addMessage(context, message) {
            context.commit(mutations.SET_MESSAGES, message);
        },
        addAlert(context, alert) {
            context.commit(mutations.ADD_ALERT, alert);
        }
    }
}